import React, { useState } from 'react'
import useKeypress from 'react-use-keypress'
import { Link } from 'react-router-dom'
import Header from '../Header/Header'
import Aside from '../Aside/Aside'

import './SettingsList.scss'

const SettingsList = () => {
    const items = [
        {
            id: 1,
            name: 'Jezik',
            clickable: true,
            description: 'Odaberi jezik korisničkog sučelja, audio zapisa i podnaslova.'
        },
        {
            id: 2,
            name: 'Video & Audio',
            clickable: true,
            description: ''
        },
        {
            id: 3,
            name: 'Moji uređaji',
            clickable: false,
            description: ''
        },
        {
            id: 4,
            name: 'Profili',
            clickable: true,
            description: ''
        },
        {
            id: 5,
            name: 'Moj prijamnik',
            clickable: true,
            description: ''
        },
        {
            id: 6,
            name: 'Pretraživanje programa',
            clickable: true,
            description: ''
        },
        {
            id: 7,
            name: 'Pravila privatnosti',
            clickable: false,
            description: ''
        },
        {
            id: 8,
            name: 'Tehničke informacije',
            clickable: false,
            description: ''
        },
        {
            id: 9,
            name: 'Ostale postavke',
            clickable: false,
            description: ''
        },
        {
            id: 10,
            name: 'Verzija sustava',
            clickable: false,
            description: ''
        }
    ]

    const [activeItem, setActiveItem] = useState(items[0])
    var ok

    const nextItem = () => {
        if (activeItem.id < 10) {
            return items[activeItem.id]
        }
        return items[0]
    }

    const previousItem = () => {
        if (activeItem.id > 1) {
            return items[activeItem.id - 2]
        }
        return items[9]
    }

    useKeypress(['ArrowDown', 'ArrowUp'], event => {
        if (event.key === 'ArrowDown') {
            event.preventDefault()
            setActiveItem(nextItem())
        }
        if (event.key === 'ArrowUp') {
            event.preventDefault()
            setActiveItem(previousItem())
        }
    })

    const stateClass = item => {
        if (item.name === activeItem.name && item.clickable) {
            ok = '/' + item.name
            return 'red'
        }
        if (item.name === activeItem.name && !item.clickable) {
            ok = '/'
            return 'gray'
        }
        return ''
    }

    return (
        <div className="settings">
            <div className="settings-group">
                <Header settings />
                <div className="settings-list">
                    <h1 className="">Postavke</h1>
                    <div className="list-and-description">
                        <div className="list">
                            {items.map(item => {
                                return item.clickable ? (
                                    <Link
                                        to={`/settings/${item.name}`}
                                        key={item.id}
                                        className={`
                                        setting-item 
                                        ${stateClass(item)}
                                        `}
                                    >
                                        {item.name}
                                    </Link>
                                ) : (
                                    <div
                                        key={item.id}
                                        className={`
                                        setting-item 
                                        ${stateClass(item)}
                                        `}
                                    >
                                        {item.name}
                                    </div>
                                )
                            })}
                        </div>
                        <div className="description-s">{activeItem.description}</div>
                    </div>
                </div>
            </div>
            <Aside
                upLink={() => setActiveItem(previousItem())}
                downLink={() => setActiveItem(nextItem())}
                backLink="/menu"
                okLink={`/settings${ok}`}
            />
        </div>
    )
}

export default SettingsList
